import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import React, { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { legacy_createStore } from "redux";
import { Layout } from "./seo/Layout.jsx";

import App from "./components/App.js";
import MainPage from "./pages/MainPage.js";
import IntroductionPage from "./pages/IntroductionPage.js";
import SupportPage from "./pages/SupportPage.js";
import PrivacyPolicy from "./pages/privacy-policy.js";
import RpaPage from "./pages/RpaPage.js";
import AiSolutionPage from "./pages/AiSolutionPage.js";
import NewsPage from "./pages/NewsPage.js";
// import NewsDetail from "./pages/NewsPageDetail.js";
import CasePage from "./pages/CasePage.js";
import CasePageDetail from "./pages/CasePageDetail.js";
import Conference from "./pages/Conference.js";
import RPAPortal from "./pages/RPA_Portal.js";
import EurekaGenAI from "./pages/EurekaGenAI.js";
import Partners from "./pages/Partners.js";
import NewsLetterPage from "./pages/NewsLetterPage.js";
import NewsPageOne from "./pages/NewsPageOne.js";

// 나머지
import NewsLetterViewPage from "./pages/NewsLetterViewPage.js";
import NewsLetterViewDetail from "./pages/NewsLetterViewDetail.js";
import ConferenceDetail from "./pages/ConferenceDetail.js";
import Casebook from "./pages/Casebook.js";
import CasebookDynamic from "./pages/CasebookDynamic.js";
import CasebookDetail from "./pages/CasebookDetail.js";

// solution 페이지
import EurekaBrain from "./pages/Eureka.js";
import Trend from "./pages/Trend.js";

// 서명 페이지
import Sign from "./pages/Sign.js";

// 임시 바우처 페이지
import Voucher from "./pages/Voucher.js";

//EXPO
// import ExpoPage from "./pages/ExpoPage.js";
// import ExpoPage1 from "./pages/ExpoPage1.js";
// import ExpoPage2 from "./pages/ExpoPage2.js";
// import NotFoundPage from "./pages/NotFoundPage.js";

// AI EXPO
// import AiExpo from "./pages/AiExpo.js";
// import AiExpoLLM from "./pages/AiExpoLLM.js";
// import AiExpoECommerce from "./pages/AiExpoECommerce.js";
// import AiExpoChatGPT from "./pages/AiExpoChatGPT.js";

/*
 * ─────────── [ react-redux : State(상태관리)를 전역적으로 사용 할 수 있게 해줌. ] ───────────
 * ─────────── [ Provider 컴포넌트 안에 있는 컴포넌트만 사용 가능 ] ───────────────────────────
 */
function reducer(currentState, action) {
  if (currentState === undefined) {
    return {
      loginSuccess: false,
    };
  }

  const notice = { ...currentState };
  if (action.type === "success") {
    notice.loginSuccess = true;
  } else {
    notice.loginSuccess = false;
  }
  return notice;
}
const store = legacy_createStore(reducer);

function ForceNonWww() {
  useEffect(() => {
    const { protocol, hostname, port, pathname, search, hash } =
      window.location;
    if (hostname.startsWith("www.")) {
      const cleanHost = hostname.replace(/^www\./, "");
      const newUrl = `${protocol}//${cleanHost}${
        port ? `:${port}` : ""
      }${pathname}${search}${hash}`;
      window.location.replace(newUrl); // 히스토리에 남기지 않고 강제 이동
    }
  }, []);

  return null; // 아무 것도 렌더링하지 않음
}

/*
 *  ─────────── [↓ 화면 컴포넌트 호출 부분 ] ─────────────────────────────────────────────────
 */

function Main() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Provider store={store}>
          <ForceNonWww />
          <Layout>
            <Routes>
              {/*-> element가 App컴포넌트로 설정된 컴포넌트들은 App컴포넌트에서 Outlet컴포넌트로 감싸져 있는거임 */}
              <Route path="/" element={<App />}>
                {/* - main page */}
                <Route index element={<MainPage />} />
                {/* - company page */}
                <Route path="company">
                  <Route index element={<MainPage />} />
                  <Route path="introduction" element={<IntroductionPage />} />
                  <Route path="support" element={<SupportPage />} />
                  <Route path="PrivacyPolicy" element={<PrivacyPolicy />} />
                </Route>
                {/* - business page */}
                <Route path="business">
                  <Route index element={<MainPage />} />
                  <Route path="aisolution" element={<AiSolutionPage />} />
                  <Route path="eurekagenai" element={<EurekaGenAI />} />
                  <Route path="rpa" element={<RpaPage />} />
                  <Route path="rpaportal" element={<RPAPortal />} />
                  <Route path="voucher" element={<Voucher />} />
                  {/* solution page */}
                  <Route path="eureka" element={<EurekaBrain />} />
                  <Route path="trend" element={<Trend />} />
                </Route>
                {/* - solution page (redirect to business) */}
                <Route path="solution">
                  <Route
                    index
                    element={<MainPage />}
                  />
                  <Route
                    path="eureka.html"
                    element={<Navigate to="/business/eureka" replace />}
                  />
                  <Route
                    path="trend.html"
                    element={<Navigate to="/business/trend" replace />}
                  />
                  <Route
                    path="company.html"
                    element={<Navigate to="/company/introduction" replace />}
                  />
                  <Route
                    path="contact.html"
                    element={<Navigate to="/company/support" replace />}
                  />
                  <Route
                    path="pricing.html"
                    element={<Navigate to="/company/support" replace />}
                  />
                  <Route
                    path="aibrain.html"
                    element={<Navigate to="/business/rpaportal" replace />}
                  />
                </Route>
                {/* - media page */}
                <Route path="media">
                  <Route index element={<MainPage />} />
                  <Route path="news" element={<NewsPage />} />
                  {/* <Route path="news/newsDetail" element={<NewsDetail />} /> */}
                  <Route path="news/detail" element={<NewsPageOne />} />
                  <Route path="case" element={<CasePage />} />
                  <Route path="case/caseDetail" element={<CasePageDetail />} />
                  <Route path="conference" element={<Conference />} />
                  <Route
                    path="conference/detail"
                    element={<ConferenceDetail />}
                  ></Route>
                  <Route
                    path="newsletter/detailpage"
                    element={<NewsLetterViewDetail />}
                  />
                  <Route path="casebook" element={<Casebook />} />
                  <Route
                    path="casebook/:custom_url"
                    element={<CasebookDynamic />}
                  />
                  <Route
                    path="casebooks/detail/:id"
                    element={<CasebookDetail />}
                  />
                  <Route path="newsletter" element={<NewsLetterViewPage />} />
                </Route>

                {/* - partners page */}
                <Route path="partners">
                  <Route index element={<MainPage />} />
                  <Route path="partners" element={<Partners />} />
                </Route>
                <Route
                  path="*"
                  element={
                    window.location.pathname.includes("wp-login") ||
                    window.location.pathname.includes("wp-admin") ? (
                      <Navigate
                        to={window.location.pathname + window.location.search}
                        replace
                      />
                    ) : (
                      <MainPage />
                    )
                  }
                />
              </Route>

              {/* 메일 - 서명 페이지 */}
              <Route path="sign" element={<Sign />} />

              {/* expo page  */}
              {/* <Route path="expo">
                  <Route path="rpa" element={<ExpoPage />} />
                  <Route path="rpa1" element={<ExpoPage1 />} />
                  <Route path="rpa2" element={<ExpoPage2 />} />
                </Route>
                <Route path="*" element={<MainPage />} /> */}

              {/* AI EXPO KOREA */}
              {/* <Route path="aiexpo" element={<AiExpo />} />
                <Route path="aiexpoLLM" element={<AiExpoLLM />} />
                <Route path="aiexpoECommerce" element={<AiExpoECommerce />} />
                <Route path="aiexpoChatGPT" element={<AiExpoChatGPT />} /> */}

              {/* extra api */}
              <Route path="newslettersubscribe" element={<NewsLetterPage />} />

              {/* 0502현재 빈페이지고 내용하드코딩한 개인정보방침페이지 만들어서 붙이기만하면됨*/}
              <Route path="privacy-policy" />
            </Routes>
          </Layout>
        </Provider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default Main;
